import { SET_KONFIGURASI_MENU } from "../types";

export const setKonfigurasiMenu = items => ({
  type: SET_KONFIGURASI_MENU,
  payload: items,
});
